export class NotificationSubTemplateResponseModel
{
  id:number;
  appNotificationId :number;
  appNotificationEventName? :string;
  appNotificationEmailTemplateFormat?:string;
  appNotificationSMSTemplateFormat?:string;
  appNotificationTemplateSubject?:string;
  appNotificationInSms:boolean;
  appNotificationInEmail:boolean;
  isEmailChecked:boolean;
  isSMSChecked:boolean;
  isActive:boolean;
  createdByUserInfoId:number;
  modifiedByUserInfoId:number;
  dateTimeCreated:Date;
  dateTimeLastModified :Date;
  isAppInvitationTagPresent:boolean;
}

export class InsuranceProvider{
  crmInsurancePatientId:number;
   insuranceProviderName:string;
}

export class NotificationSubTemplateupdateModel
{
    AppNotificationId :number;
    IsGroupEmail :boolean;
    CheckedValue:boolean;
}
